import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/layouts/AdminLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import MunicipalitiesPage from "@/pages/MunicipalitiesPage";
import PublisherSitesPage from "@/pages/PublisherSitesPage";
import PlacementsPage from "@/pages/PlacementsPage";
import CampaignsPage from "@/pages/CampaignsPage";
import CreativesPage from "@/pages/CreativesPage";
import LivePreviewPage from "@/pages/LivePreviewPage";
import AdSizesPage from "@/pages/AdSizesPage";
import ReportsPage from "@/pages/ReportsPage";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import UsersPage from "@/pages/UsersPage";
import SystemStatusPage from "@/pages/SystemStatusPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/municipalities" element={<MunicipalitiesPage />} />
            <Route path="/publisher-sites" element={<PublisherSitesPage />} />
            <Route path="/placements" element={<PlacementsPage />} />
            <Route path="/campaigns" element={<CampaignsPage />} />
            <Route path="/creatives" element={<CreativesPage />} />
            <Route path="/live-preview" element={<LivePreviewPage />} />
            <Route path="/ad-sizes" element={<AdSizesPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/system" element={<SystemStatusPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
